<template>
  <div ref="panelRsPases" v-resize="configPlano">
    <v-container fluid class="mt-1 pt-0" v-bind:class="{ 'red darken-1': alert }">
      <v-layout row wrap>
        <v-flex xs12>
          <v-subheader class="title">Seleccione su ticket</v-subheader>
        </v-flex>
        <v-flex xs12 v-if="loading">
          <v-card-text>
            <p class="text-xs-center">
              Buscando tickets para la habitacion
            </p>
            <v-progress-linear indeterminate color="red" class="mb-0" height="1"></v-progress-linear>
          </v-card-text>
        </v-flex>
        <v-flex xs12 v-if="!loading" class="pt-0">
          <v-chip label color="orange darken-1" text-color="white" v-if="obligatorio">
            Los tickets para esta habitación son obligatorios
          </v-chip>
          <v-chip color="green" text-color="white" v-if="ticketSeleccionado.mostrar" class="text-capitalize">
            <v-avatar class="green darken-4"><v-icon class="caption">fas fa-check</v-icon></v-avatar>
            {{ ticketSeleccionado.ticket.nombre.toLowerCase() }}
          </v-chip>
        </v-flex>
        <v-flex xs12 v-if="!loading">
          <v-tabs v-model="active" color="white" dark fixed-tabs slider-color="red darken-4" grow>
            <v-tab v-for="(s, indxs) in solapas" :key="indxs" ripple class="black--text">
              {{ s.titulo }}
            </v-tab>
            <v-tab-item v-for="(s, indxc) in solapas" :key="indxc">
              <v-card flat color="transparent">
                <v-card-text>
                  <component
                    v-bind:is="s.componente"
                    :data="s.data"
                    :plano="plano"
                    :mostrarBuscador="muestraBuscadorInterno()"
                    :ticketTipo="0"
                    :proveedor="data.proveedor"
                  ></component>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// ListadoTicketsPredeterminados
import ListadoTicketsFlexibles from "@/components/pases/ListadoTicketsFlexibles.vue"
import BuscadorPases from "@/components/pases/BuscadorPases.vue"

export default {
  name: "contenedorPasesHoteles",
  props: {
    data: {
      type: Object,
      default: function() {
        return { pases: [] }
      }
    },
    obligatorio: {
      type: Boolean,
      default: false
    },
    ticketsHabitacion: {
      type: Array,
      default: function() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    alert: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ListadoTicketsFlexibles,
    BuscadorPases
  },
  mounted() {},
  created() {
    this.solapas = []
    this.tomarTickets()
    this.muestraBuscadorInterno()
  },
  activated() {},
  methods: {
    tomarTickets() {
      this.tomarFechaFlexibles()
      this.tomarFechaPredeterminada()
      this.tomarPromocionales()
    },
    tomarFechaPredeterminada() {
      try {
        const calendarios = this.data.pases.find(p => p.tipo === "C")
        if (calendarios == undefined) {
          return
        }
        const toAdd = {
          rs: calendarios.rs,
          comparador: calendarios.comparador,
          regimen: calendarios.regimen
        }
        this.addSolapa("Tickets con fechas predeterminada", "BuscadorPases", toAdd)
      } catch (e) {}
    },
    tomarFechaFlexibles() {
      try {
        const flexibles = this.data.pases.find(p => p.tipo === "F")
        if (flexibles == undefined) {
          return
        }
        const filtrados = flexibles.rs.filter(r => r.valor != 1000)
        if (filtrados.length === 0) {
          return
        }
        const toAdd = {
          rs: filtrados,
          comparador: this.data.pases[0].comparador
        }
        this.addSolapa("Tickets con fechas flexibles", "ListadoTicketsFlexibles", toAdd)
      } catch (e) {
        console.log(e)
      }
    },
    tomarPromocionales() {
      try {
        const promocionales = this.data.pases.find(p => p.tipo === "F")
        if (promocionales == undefined) {
          return
        }
        const filtrados = promocionales.rs.filter(r => r.valor == 1000)
        if (filtrados.length === 0) {
          return
        }
        if (filtrados[0].tickets.length === 0) {
          return
        }
        const toAdd = {
          rs: filtrados,
          comparador: this.data.pases[0].comparador
        }
        this.addSolapa("Tickets Promocionales", "ListadoTicketsFlexibles", toAdd)
      } catch (e) {
        console.log(e)
      }
    },
    addSolapa(titulo, componente, data) {
      this.solapas.push({ titulo: titulo, componente: componente, data: data })
    },
    configPlano() {
      if (this.$refs.panelRsPases == undefined) {
        return
      }
      let width = this.$refs.panelRsPases.clientWidth
      this.plano = "row"
      if (width <= 400 && width != 0) {
        this.plano = "column"
      }
    },
    muestraBuscadorInterno() {
      return !this.data.pases.some(tipoPase => tipoPase.comparador === undefined)
    }
  },
  data() {
    return {
      solapas: [],
      active: null,
      plano: "row"
    }
  },
  computed: {
    ticketSeleccionado: function() {
      if (this.ticketsHabitacion.length > 0) {
        return { mostrar: true, ticket: this.ticketsHabitacion[0] }
      }
      return { mostrar: false }
    }
  },
  watch: {
    data: function(newVal, oldVal) {
      // watch it
      this.solapas = []
      this.tomarTickets()
      this.muestraBuscadorInterno()
    }
  }
}
</script>
